import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatInTimeZone } from 'date-fns-tz';
import { Button } from '@a-ui/react';
import classNames from 'classnames';

import { fetchTransactionsCard } from 'actions/transactions';

import styles from './Transactions.module.css';

const PAGE_SIZE = 8;

const Transactions = ({ cardNumber }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [localTransactions, setLocalTransactions] = useState([]);
  const { transactions } = useSelector(state => ({
    transactions: state.transactions,
  }));

  const onLoadMore = () => {
    dispatch(fetchTransactionsCard(cardNumber, page + 1, PAGE_SIZE)).then((response) => {
      const { hasNextPage, pageNumber, transactions = [] } = response.payload;
      setPage(pageNumber);
      setShowLoadMore(hasNextPage);
      setLocalTransactions(prevTransactions => [
        ...prevTransactions,
        ...transactions,
      ]);
    });
  }

  useEffect(() => {
    onLoadMore();
  }, []);

  if (transactions.items.length === 0) {
    return (
      <p className="u-margin-top">Er zijn nog geen afvalstortingen.</p>
    )
  }

  return (
    <div>
      <table className={classNames('a-table', 'u-margin-top-xs', styles.table)}>
        <thead className={styles.thead}>
          <tr>
            <th>Tijdsstip</th>
            <th>Fractie</th>
            <th>Locatie</th>
            <th className="u-text-right">Bedrag</th>
          </tr>
        </thead>
        <tbody>
          {
            localTransactions.map((item, index) => (
              <tr key={`transactions-${index}`}>
                <td className="small">{formatInTimeZone(item.timestamp, 'Europe/Brussels', 'dd/MM/yyyy HH:mm')} u</td>
                <td className="small">{item.fraction}</td>
                <td className="small">{item.street}</td>
                <td className="small u-text-right">{item.amount === 0 ? 'Gratis' : `- € ${item.amount.toString().replaceAll('.', ',')}`}</td>
              </tr>
            ))
          }
        </tbody>
      </table>
      {showLoadMore && <span className={styles.loader}><Button
        emphasis="low"
        {...(transactions.loading && {
          addOn: {
            type: 'spinner',
          },
        })}
        onClick={onLoadMore}
      >Meer laden</Button>
      </span>}
    </div>
  );
}

export default Transactions;
